var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('el-card',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"data"},[_c('div',{staticClass:"data-title flex-space-between",attrs:{"slot":"header"},slot:"header"},[_c('p',[_vm._v("PayPal Payment Requests")])]),_c('Table')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }